import types from "../types";

const actions = {
  // Login
  createCustomer: (data) => {
    return { type: types.CREATE_CUSTOMER, payload: data };
  },

  // Update
  updateCustomer: (data) => {
    return { type: types.UPDATE_CUSTOMER, payload: data };
  },

  // Logout
  deleteCustomer: { type: types.LOGOUT_CUSTOMER },
};

export default actions;
